import styled from 'styled-components';
import ShimmerEffect from 'ggApp/shared/components/shimmerEffect';
import ProductResolutionImage from 'ggApp/shared/components/resolutionImage/ProductResolutionImage';

const ProductImage = ShimmerEffect(ProductResolutionImage);

export const Container = styled.section`
    display: flex;
    flex-wrap: nowrap;
    background: ${(props) => props.theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
`;

export const ImageWrap = styled.div`
    position: relative;
`;

export const Image = styled(ProductImage)`
    width: 48px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
`;

export const Name = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline}
`;

export const PriceWrap = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const PriceInfo = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const MinMonths = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    margin-left: 8px;
    color: ${(props) => props.theme.colors['Level 4']};
`;

export const CoreAttribute = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph}
    color: ${({ theme }) => theme.colors['Level 5']};
`;
